// extracted by mini-css-extract-plugin
export default {"main":"welcome_main__Y60E3","logo":"welcome_logo__UuczC"};